interface SectionHeaderProps {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  align?: "left" | "center";
  dark?: boolean;
}

export default function SectionHeader({
  eyebrow,
  title,
  subtitle,
  align = "left",
  dark = false,
}: SectionHeaderProps) {
  const alignCls = align === "center" ? "text-center mx-auto" : "text-left";
  return (
    <div className={`max-w-2xl ${alignCls}`}>
      {eyebrow && (
        <span
          className={`inline-flex items-center gap-2 text-xs font-semibold tracking-[0.2em] uppercase ${
            dark ? "text-primary-400" : "text-primary-600"
          }`}
        >
          <span className="w-6 h-px bg-primary-500"></span>
          {eyebrow}
        </span>
      )}
      <h2
        className={`mt-4 font-heading text-3xl md:text-4xl font-bold leading-tight tracking-tight ${
          "text-foreground-950"
        }`}
      >
        {title}
      </h2>
      {subtitle && (
        <p
          className={`mt-4 text-lg leading-relaxed ${
            "text-foreground-600"
          }`}
        >
          {subtitle}
        </p>
      )}
    </div>
  );
}